import { Card } from '@mui/material';
import React, { FunctionComponent } from 'react';

interface Props {
  errorMessages: string[];
}

const ErrorMessages: FunctionComponent<Props> = ({ errorMessages }) => {
  if (errorMessages.length === 0) {
    return null;
  }

  return (
    <Card variant="outlined" className="border-dotted border-red-500 !bg-red-50 p-2">
      {errorMessages.map((errorMessage, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <p key={index} className="font-semibold text-red-500">
          {errorMessage}
        </p>
      ))}
    </Card>
  );
};

export { ErrorMessages };
